import type { FeatureFlag } from './feature-flag-types'

export const FeatureFlagName = {
  // ==========================================
  // Flags Permanentes
  // Precisam ser revisadas periodicamente para avaliar se ainda fazem sentido ou se devem ser removidas
  // ==========================================
  ENABLE_CONTACT_VALIDATION: {
    name: 'skillcustomer-contact-validation',
    defaultValue: false
  },
  ENABLE_ONBOARDING_CONTACT_VALIDATION: {
    name: 'skillcustomer-onboarding-contact-validation',
    defaultValue: false
  },
  COMPANIES_WITH_CUSTOM_HELP_CENTER: {
    name: 'skillcustomer-companies-custom-help-center',
    defaultValue: []
  },
  PARTNER_CANCEL_NOT_ALLOWED: {
    name: 'skillcustomer-partner-cancel-not-allowed',
    defaultValue: []
  },
  COMPANIES_WITH_PROFILE_ASSESSMENT: {
    name: 'skillcustomer-companies-with-profile-assessment',
    defaultValue: false
  },
  USER_SPACE_ENABLED: {
    name: 'skillcustomer-user-space-enabled',
    defaultValue: false
  },
  ENGAGE_DATA: {
    name: 'skillcustomer-company-dashboards-engage',
    defaultValue: {}
  },

  // ==========================================
  // Novas flags devem ser adicionadas abaixo, seguindo a mesma estrutura dos objetos anteriores
  // ==========================================
  ENABLE_CAREER_MENTOR: {
    name: 'skill-customer-enable-career-mentor',
    defaultValue: false
  },
  ENABLE_PDI_RECOMMENDATIONS: {
    name: 'skill-customer-enable-pdi-recommendations',
    defaultValue: false
  },
  ENABLE_FIT_SCORE: {
    name: 'skill-customer-enable-fit-score',
    defaultValue: false
  },
  ENABLE_POST_FETCH_SKILL_RECOMMENDATIONS: {
    name: 'skill-customer-post-fetch-skill-recommendations',
    defaultValue: false
  },
  ENABLE_SPONSORSHIP_RENEWAL: {
    name: 'skill-customer-enable-sponsorship-renewal',
    defaultValue: false
  },
  // Mesma chave lida pelo backend (FeatureFlagEnum.PRODUCT_INTEREST_WITHOUT_OFFER). Uma flag paralela
  // dessincronizaria os dois lados: com ela ligada só aqui, a PDV renderizaria o CTA de "avise-me" contra
  // um endpoint que ainda responde 409.
  ENABLE_PRODUCT_INTEREST_WITHOUT_OFFER: {
    name: 'skill-customer-web-enable-product-interest-without-offer',
    defaultValue: false
  },
  ENABLE_USER_LEARNING_PREFERENCES: {
    name: 'skill-customer-enable-user-learning-preferences',
    defaultValue: false
  }
} as const

/**
 * Type helper for TypeScript
 */
export type FeatureFlagNameType = typeof FeatureFlagName

/**
 * Helper to get all flags as array
 * Used internally for initialization and caching
 */
export const getAllFlags = (): FeatureFlag[] => Object.values(FeatureFlagName)
